import { Star, ShieldCheck } from "lucide-react";

const GOOGLE_REVIEWS_URL = "https://www.google.com/maps/place/928+Wraps/data=!4m2!3m1!1s0x83bb0e299cb5635d:0x16765e0e0d34903";

/**
 * Universal trust ribbon — sits below every hero on every page.
 * Baseline credibility layer. All numbers verified from Google Business Profile.
 */
export default function TrustRibbon({ compact = false }) {
  return (
    <div data-testid="trust-ribbon" className={`border-y border-neutral-200 bg-white ${compact ? "py-4" : "py-6"}`}>
      <div className="wrap flex flex-wrap items-center justify-between gap-6 text-sm">
        <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <div className="flex gap-0.5">
            {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-[var(--red)] text-[var(--red)]" />)}
          </div>
          <span className="font-semibold text-neutral-900">5.0</span>
          <span className="text-neutral-500 hidden sm:inline">Google rating</span>
        </a>
        <div className="hidden md:flex items-center gap-2 text-neutral-700">
          <ShieldCheck size={14} className="text-[var(--red)]" />
          <span className="font-semibold">Owner operated</span>
          <span className="text-neutral-500">· Dave Mitchell</span>
        </div>
        <div className="text-neutral-700">
          <span className="font-semibold">4,382</span>
          <span className="text-neutral-500 ml-1">Projects completed</span>
        </div>
        <div className="hidden lg:block text-neutral-500 text-xs tracking-[0.15em] uppercase">
          Serving Prescott · Prescott Valley · Chino Valley · Northern AZ
        </div>
      </div>
    </div>
  );
}
